import React, { useEffect, useRef, useState } from "react";
import Chart from "chart.js/auto";

function SalesGraph() {

  const [isarea, setisarea] = useState(true)
  const [isdonut, setisdonut] = useState(false)
    const chartRef = useRef(null);
    const chartReff = useRef(null);
    
    useEffect(() => {
      if (chartRef.current) {
        const salesChartCanvas = chartRef.current.getContext("2d");
  
        const salesChartData = {
          labels: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
          ],
          datasets: [
            {
              label: "Digital Goods",
              backgroundColor: "rgba(60,141,188,0.9)",
              borderColor: "rgba(60,141,188,0.8)",
              pointRadius: false,
              pointColor: "#3b8bba",
              pointStrokeColor: "rgba(60,141,188,1)",
              pointHighlightFill: "#fff",
              pointHighlightStroke: "rgba(60,141,188,1)",
              data: [28, 48, 40, 19, 86, 27, 90],
            },
            {
              label: "Electronics",
              backgroundColor: "rgba(210, 214, 222, 1)",
              borderColor: "rgba(210, 214, 222, 1)",
              pointRadius: false,
              pointColor: "rgba(210, 214, 222, 1)",
              pointStrokeColor: "#c1c7d1",
              pointHighlightFill: "#fff",
              pointHighlightStroke: "rgba(220,220,220,1)",
              data: [65, 59, 80, 81, 56, 55, 40],
            },
          ],
        };
  
        const salesChartOptions = {
          maintainAspectRatio: false,
          responsive: true,
          plugins: {
            legend: {
              display: false,
            },
          },
          scales: {
            x: {
              grid: {
                display: false,
              },
            },
            y: {
              grid: {
                display: false,
              },
            },
          },
        };
        
  
        new Chart(salesChartCanvas, {
          type: "line",
          data: salesChartData,
          options: salesChartOptions,
        });
      }
    }, [chartRef,isarea]);


    useEffect(() => {
      if (chartReff.current) {
        const salesChartCanvas = chartReff.current.getContext("2d");
  
        const salesChartData = {
          labels: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
          ],
          datasets: [
            {
              label: "Digital Goods",
              backgroundColor: [
                "rgba(60,141,188,0.9)",
                "rgba(255,0,0,0.9)",
                "rgba(255,255,0,0.9)",
                "rgba(0,255,0,0.9)",
                "rgba(0,0,255,0.9)",
                "rgba(255,0,255,0.9)",
                "rgba(0,255,255,0.9)",
              ],
              data: [28, 48, 40, 19, 86, 27, 90],
            },
            {
              label: "Electronics",
              backgroundColor: [
                "rgba(210, 214, 222, 1)",
                "rgba(255,0,0,0.9)",
                "rgba(255,255,0,0.9)",
                "rgba(0,255,0,0.9)",
                "rgba(0,0,255,0.9)",
                "rgba(255,0,255,0.9)",
                "rgba(0,255,255,0.9)",
              ],
              data: [65, 59, 80, 81, 56, 55, 40],
            },
          ],
        };
  
        new Chart(salesChartCanvas, {
          type: "doughnut",
          data: salesChartData,
          options: {
            maintainAspectRatio: false,
            responsive: true,
            legend: {
              display: true,
              position: "bottom",
            },
          },
        });
      }
    }, [chartRef,isdonut]);


    const areafunction =()=>{
      setisarea(true)
      setisdonut(false)
    }

    const donutFunction =()=>{
      setisdonut(true)
      setisarea(false)
    }


    


  return (
    <div className="card" style={{width:"50%"}}>
              <div className="card-header">
                <h3 className="card-title">
                  <i className="fas fa-chart-pie mr-1" />
                  Sales
                </h3>
                <div className="card-tools">
                  <ul className="nav nav-pills ml-auto">
                    <li className="nav-item">
                      <button
                        className={`nav-link ${isarea && "active"}`}
                        onClick={areafunction}
                        style={{color:'#fff',marginRight:5}}
                      >
                        Area
                      </button>
                    </li>
                    <li className="nav-item">
                      <button
                        className={`nav-link ${isdonut && "active"}`}
                        onClick={donutFunction}
                        style={{color:'#fff'}}
                      >
                        Donut
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
              {/* /.area body */}
              {isarea && 
              <div className="card-body">
                <div className="tab-content p-0">
                  {/* Morris chart - Sales */}
                  <div
                    className="chart tab-pane active"
                    id="revenue-chart"
                    style={{ position: "relative", height: "300px" }}
                  >
                    <canvas
                      ref={chartRef}
                      id="revenue-chart-canvas"
                      height={300}
                      style={{ height: "300px" }}
                    />
                  </div>
                  <div
                    className="chart tab-pane"
                    id="sales-chart"
                    style={{ position: "relative", height: "300px" }}
                  >
                    <canvas
                      id="sales-chart-canvas"
                      height={300}
                      style={{ height: "300px" }}
                    />
                  </div>
                </div>
              </div>}

              {isdonut && 
              <div className="card-body">
              <div className="tab-content p-0">
                {/* Morris chart - Sales */}
                <div
                  className="chart tab-pane active"
                  id="revenue-chart"
                  style={{ position: "relative", height: "300px" }}
                >
                  <canvas
                    ref={chartReff}
                    id="revenue-chart-canvas"
                    height={300}
                    style={{ height: "300px" }}
                  />
                </div>
                <div
                  className="chart tab-pane"
                  id="sales-chart"
                  style={{ position: "relative", height: "300px" }}
                >
                  <canvas
                    id="sales-chart-canvas"
                    height={300}
                    style={{ height: "300px" }}
                  />
                </div>
              </div>
            </div>}
              {/* /.area body */}
            </div>
  )
}

export default SalesGraph








